import styled from 'styled-components';

export const FocusReset = styled.div`
  clip: rect(1px, 1px, 1px, 1px);
  clip-path: inset(100%);
  position: fixed;
`;

export const Main = styled.main`
  &:empty {
    min-height: 100vh;
  }
`;
